import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
  DashboardOutlined,
  WalletOutlined,
  UserOutlined,
  RiseOutlined,
  FallOutlined,
  AppstoreAddOutlined,
  ContactsOutlined,
  TableOutlined,
  TeamOutlined,
  FundOutlined,
  FileTextOutlined,
  SolutionOutlined,
  AuditOutlined,
  BarChartOutlined,
  LineChartOutlined,
  FileDoneOutlined,
  SafetyCertificateOutlined,
  PartitionOutlined,
  DollarCircleOutlined,
  ShopOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";

const dashBoardNavTree = [
  {
    key: "financial",
    path: "",
    title: "sidenav.pages.financial",
    breadcrumb: false,
    submenu: [
      {
        key: "dashboard",
        path: `${APP_PREFIX_PATH}/dashboard`,
        title: "sidenav.pages.dashboard",
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "financialReports",
        title: "sidenav.pages.financial",
        icon: WalletOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "accountsPayable",
            path: `${APP_PREFIX_PATH}/contas-a-pagar`,
            icon: FallOutlined,
            title: "sidenav.pages.accountsPayable",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "accountsReceivable",
            path: `${APP_PREFIX_PATH}/contas-a-receber`,
            title: "sidenav.pages.accountsReceivable",
            icon: RiseOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "serviceOrders",
            path: `${APP_PREFIX_PATH}/ordens-de-servico`,
            title: "sidenav.pages.serviceOrders",
            breadcrumb: false,
            icon: FileTextOutlined,
            submenu: [],
          },
          {
            key: "negotiationApprovals",
            path: `${APP_PREFIX_PATH}/aprovacao-de-negociacoes`,
            title: "sidenav.pages.negotiationApprovals",
            breadcrumb: false,
            icon: SafetyCertificateOutlined,
            submenu: [],
          },
          {
            key: "paymentCustody",
            path: `${APP_PREFIX_PATH}/custodia-de-pagamento`,
            title: "sidenav.pages.paymentCustody",
            breadcrumb: false,
            icon: AuditOutlined,
            submenu: [],
          },
          {
            key: "accountPlan",
            path: `${APP_PREFIX_PATH}/plano-de-contas`,
            title: "sidenav.pages.accountPlan",
            breadcrumb: false,
            icon: PartitionOutlined,
            submenu: [],
          },
        ],
      },
      {
        key: "billing",
        title: "sidenav.pages.billing",
        icon: DollarCircleOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "billingForecast",
            path: `${APP_PREFIX_PATH}/previsao-de-faturamento`,
            title: "sidenav.pages.billingForecast",
            breadcrumb: false,
            icon: LineChartOutlined,
            submenu: [],
          },
          {
            key: "readyToBill",
            path: `${APP_PREFIX_PATH}/a-faturar`,
            title: "sidenav.pages.readyToBill",
            breadcrumb: false,
            icon: FileDoneOutlined,
            submenu: [],
          },
          {
            key: "productionSummary",
            path: `${APP_PREFIX_PATH}/resumo-producao`,
            title: "sidenav.pages.productionSummary",
            breadcrumb: false,
            icon: BarChartOutlined,
            submenu: [],
          },
        ],
      },
      {
        key: "commercial",
        title: "sidenav.pages.commercial",
        icon: ShopOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "quotes",
            path: `${APP_PREFIX_PATH}/orcamentos`,
            title: "sidenav.pages.quotes",
            breadcrumb: false,
            icon: FileProtectOutlined,
            submenu: [],
          },
        ],
      },
      {
        key: "reports",
        path: `${APP_PREFIX_PATH}/relatorios`,
        title: "sidenav.pages.reports",
        icon: FundOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "registrations",
        title: "sidenav.pages.registrations",
        icon: AppstoreAddOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "clients",
            path: `${APP_PREFIX_PATH}/lista-de-clientes`,
            title: "sidenav.pages.clients",
            icon: UserOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "companies",
            path: `${APP_PREFIX_PATH}/empresas`,
            title: "sidenav.pages.companies",
            icon: ContactsOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "salesReps",
            path: `${APP_PREFIX_PATH}/representantes`,
            title: "sidenav.pages.salesReps",
            icon: SolutionOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "pricingTables",
            path: `${APP_PREFIX_PATH}/tabelas-de-preco`,
            title: "sidenav.pages.pricingTables",
            icon: TableOutlined,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "users",
        title: "sidenav.pages.users",
        icon: TeamOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "userList",
            path: `${APP_PREFIX_PATH}/lista-de-usuarios`,
            title: "sidenav.pages.userlist",
            icon: UserOutlined,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
